import { StyleSheet } from 'react-native';
import { WARMUP_COLORS } from '../../../src/quiz/constants/warmup.constants';
import { HILO_COLORS, HILO_CHIP_LEDGE } from '../../../src/quiz/constants/higherLower.constants';

const CHOICE_FACE_HEIGHT = 64;
const CHOICE_FACE_HEIGHT_COMPACT = 50;

export const higherLowerViewStyles = StyleSheet.create({
  container: { flex: 1 },
  centered: { flex: 1, alignItems: 'center', justifyContent: 'center', gap: 14, padding: 24 },
  message: { color: WARMUP_COLORS.textDim, fontSize: 14, fontWeight: '500', textAlign: 'center' },
  retryButton: {
    backgroundColor: WARMUP_COLORS.purple,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  retryText: { color: WARMUP_COLORS.textOnBright, fontSize: 15, fontWeight: '800' },
  pressedDim: { opacity: 0.7 },

  // One fixed page (no scroll): the field flexes to absorb the leftover height so the whole game —
  // title, streak, both cards, coin row, and the buttons below — always fits one screen. Cards shrink
  // (flex) on short phones rather than pushing content off-screen.
  content: { flex: 1, paddingHorizontal: 16, paddingTop: 6 },

  titleRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 2 },
  title: { fontSize: 17, fontWeight: '800', color: WARMUP_COLORS.text, letterSpacing: -0.2 },
  rewardChip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    backgroundColor: '#10251C',
    borderWidth: 1,
    borderColor: '#1F4D39',
    borderRadius: 9999,
    paddingVertical: 3,
    paddingHorizontal: 9,
  },
  rewardChipText: { fontSize: 11, fontWeight: '700', color: WARMUP_COLORS.green },
  coinDot: {
    width: 12,
    height: 12,
    borderRadius: 9999,
    backgroundColor: WARMUP_COLORS.amber,
  },

  streakStrip: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 14, marginTop: 6 },
  streakText: { fontSize: 13, fontWeight: '700', color: WARMUP_COLORS.textDim },
  streakNum: { fontSize: 16, fontWeight: '800', color: WARMUP_COLORS.green },
  bestNum: { fontWeight: '800', color: WARMUP_COLORS.text },
  streakDivider: { width: 1, height: 14, backgroundColor: HILO_COLORS.vsBorder },

  field: { flex: 1, justifyContent: 'center', gap: 6, paddingVertical: 4 },
  vsRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 10, marginVertical: -2 },
  vsLine: { flex: 1, height: 1, backgroundColor: HILO_COLORS.vsBorder },
  vsCircle: {
    width: 34,
    height: 34,
    borderRadius: 9999,
    backgroundColor: WARMUP_COLORS.bg,
    borderWidth: 1.5,
    borderColor: HILO_COLORS.vsBorder,
    alignItems: 'center',
    justifyContent: 'center',
  },
  vsText: { fontSize: 12, fontWeight: '800', color: WARMUP_COLORS.textDim },

  coinRow: { flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 6, marginTop: 4 },
  coinProgress: { fontSize: 12, fontWeight: '600', color: WARMUP_COLORS.textFaint },
  capBanner: { fontSize: 12, fontWeight: '700', color: WARMUP_COLORS.amber },

  buttonsRow: { flexDirection: 'row', gap: 10, paddingHorizontal: 16, paddingTop: 6, paddingBottom: 14 },
  // Outer wrapper paints the chip "ledge" (shadow colour); the gradient face sits on top and
  // leaves the ledge exposed at the bottom — mirrors the Wordle tile/keyboard raised-chip idiom.
  choiceButton: {
    flex: 1,
    height: CHOICE_FACE_HEIGHT + HILO_CHIP_LEDGE,
    borderRadius: 16,
    justifyContent: 'flex-start',
  },
  // Shorter buttons on phones/small screens (desktop keeps the full height).
  choiceButtonCompact: { height: CHOICE_FACE_HEIGHT_COMPACT + HILO_CHIP_LEDGE },
  choiceFaceCompact: { height: CHOICE_FACE_HEIGHT_COMPACT },
  higherOuter: { backgroundColor: HILO_COLORS.higherShadow },
  lowerOuter: { backgroundColor: HILO_COLORS.lowerShadow },
  choiceFace: {
    width: '100%',
    height: CHOICE_FACE_HEIGHT,
    borderRadius: 16,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
  },
  choiceText: { fontSize: 16, fontWeight: '800', letterSpacing: 0.2 },
  higherText: { color: '#0F1720' },
  lowerText: { color: '#3A0E0E' },
  pressed: { opacity: 0.9 },
  buttonDisabled: { opacity: 0.5 },

  coinBeat: { position: 'absolute', top: '42%', left: 0, right: 0, alignItems: 'center' },
  // The "+N" beat only shows on a paid correct guess, so it is always the positive (higher) green.
  coinBeatText: { fontSize: 24, fontWeight: '800', fontVariant: ['tabular-nums'], color: HILO_COLORS.higher },
});
